module.exports = __webpack_public_path__ + "img/10-vogelspeelgoed_img2.ce3e62a9.jpg";